module.exports = __webpack_public_path__ + "media/rbs_bot.ce4327bf.mp4";